<mat-drawer-container class="container">
  <mat-drawer class="drawer" mode="side" position="start" [opened]="isOpen">
    <div class="side-menu">
      <div class="header-container">
        <div> Map Layers </div>
        <button mat-stroked-button aria-label="Clear active layer button" (click)="clearActiveFilters()"
          matTooltip="Clear all active layers"
          [matTooltipPosition]="'above'"
          matTooltipHideDelay="100000">
          <vulcan-icon icon="filter-simple"></vulcan-icon>
          <span>Clear All</span>
        </button>
      </div>
      <mat-tab-group>
        <mat-tab label="Layers">
          <tgrid-sidebar-group  title="Dates">
            <tgrid-year-selector (valueChange)="handleYearChange($event)"></tgrid-year-selector>
          </tgrid-sidebar-group>


          @for (layerGroup of mapLayerGroups | async; track layerGroup) {
            <div>
              <tgrid-map-layer-group [mapLayerGroup]="layerGroup"></tgrid-map-layer-group>
            </div>
          }
        </mat-tab>
        <mat-tab>
          <ng-template mat-tab-label>
            <span>Selected ({{ currentMapLayer().length }})</span>
          </ng-template>

          <p class="info-text">
            @if (currentMapLayer().length === 0) {
              <span
              >Toggle on a layer to see it listed below</span>
            } @else {
              Drag and drop the layer names to reorder the layers on the map
            }
          </p>


          <div cdkDropList (cdkDropListDropped)="handleDropEvent($event)">
            @for (layer of currentMapLayer(); track layer) {
              <div cdkDrag class="drag-layer-handle">
                {{ layer.get('name') }} Layer
              </div>
            }
          </div>


        </mat-tab>
      </mat-tab-group>
    </div>
  </mat-drawer>
  <mat-drawer-content class="drawer-content">
    <button class="arrow_btn" (click)="isOpen = !isOpen" mat-mini-fab color="primary"
      aria-label="Example icon button with a menu icon">
      @if (isOpen) {
        <mat-icon>arrow_back</mat-icon>
      }
      @if (!isOpen) {
        <mat-icon>arrow_forward</mat-icon>
      }
    </button>
    <tgrid-map (layerAdded)="mapLayerChange($event)" (layerRemoved)="mapLayerChange($event, false)">
    </tgrid-map>

  </mat-drawer-content>
</mat-drawer-container>

<tgrid-map-controls></tgrid-map-controls>

